/* eslint-disable @typescript-eslint/init-declarations */
import type * as React from "react";
import { useSelector } from "react-redux";
import type { ConfigurationFeaturesState, CurrentSpaceConfigurationState } from "~/areas/configuration/reducers/configurationArea";
export enum Feature {
    CommunityActionTemplates,
    MultiTenancy
}
interface GlobalConnectedProps {
    features: ConfigurationFeaturesState;
    space: CurrentSpaceConfigurationState;
}
interface FeatureToggleProps {
    feature: Feature;
    enabled?: boolean;
    children?: React.ReactNode;
}
export const FeatureToggle: React.FC<FeatureToggleProps & GlobalConnectedProps> = ({ space, features, feature, enabled = true, children }) => {
    let featureStatus: boolean;
    switch (feature) {
        case Feature.CommunityActionTemplates:
            featureStatus = features.isCommunityActionTemplatesEnabled;
            break;
        case Feature.MultiTenancy:
            featureStatus = space ? space.isMultiTenancyEnabled : false;
            break;
    }
    if ((featureStatus && enabled) || (!featureStatus && !enabled)) {
        return <span>{children}</span>;
    }
    return null;
};
FeatureToggle.displayName = "FeatureToggle"
const ConnectedFeatureToggle: React.FC<FeatureToggleProps> = (props) => {
    const features = useSelector((state: GlobalState) => state.configurationArea.features);
    const space = useSelector((state: GlobalState) => state.configurationArea.currentSpace);
    return <FeatureToggle {...props} features={features} space={space}/>;
};
ConnectedFeatureToggle.displayName = "ConnectedFeatureToggle"
export default ConnectedFeatureToggle;
